import React, { useMemo } from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { FaRegCheckCircle, FaRegTimesCircle, FaEdit } from 'react-icons/fa';

export const useMedicineColumns = ({ key, currentPage, perPage, approval, handleEdit, t }) => {
	const capitalize = (str) =>
		str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();
	const getFullName = (requester) => {
		return `${capitalize(requester.first_name)} ${capitalize(requester.last_name)}`;
	};

	return useMemo(() => {
		return [
			{
				name: '#',
				selector: (_, index) => (currentPage - 1) * perPage + index + 1,
				maxWidth: '55px',
				minWidth: '55px',
				center: true,
			},
			{
				name: t('MEDICIENS.TABLE.MEDICINE_NAME'),
				selector: row => row.name,
				grow: 2,
				wrap: true,
				sortable: true,
				sortField: 'name',
			},
			{
				name: t('MEDICIENS.TABLE.GENERIC_NAME'),
				selector: row => row.genericName,
				grow: 2,
				wrap: true,
				sortable: true,
				sortField: 'name',
			},
			...(key === 'pending' ? [
				{
					name: t('MEDICIENS.TABLE.REQUESTED_BY'),
					selector: row => getFullName(row.requester),
					minWidth: '125px',
					maxWidth: '125px',
					wrap: true
				},
				{
					name: t('MEDICIENS.TABLE.REQUESTED_ON'),
					selector: row => moment(row.created_at).format('DD-MM-YYYY'),
					minWidth: '125px',
					maxWidth: '125px',
					wrap: true,
					sortable: true,
					sortField: 'created_at',
				},
				{
					name: t('MEDICIENS.TABLE.DESCRIPTION'),
					selector: row => row.description ?? '-',
					minWidth: '125px',
					maxWidth: '125px',
					wrap: true,
					sortable: true,
					sortField: 'description',
				},
			] : []),
			{
				name: t('MEDICIENS.TABLE.TYPE'),
				selector: row => row.type,
				wrap: true,
				sortable: true,
				sortField: 'type',
			},
			{
				name: t('MEDICIENS.TABLE.MIN_AGE'),
				selector: row => row.minAge,
				wrap: true,
				sortable: true,
				sortField: 'minAge',
			},
			{
				name: t('MEDICIENS.TABLE.MAX_AGE'),
				selector: row => row.maxAge,
				wrap: true,
				sortable: true,
				sortField: 'maxAge',
			},
			{
				name: t('MEDICIENS.TABLE.STATUS'),
				cell: row => (
					<span className={row.status === 'inactive' ? 'text-danger' : 'text-success'}>
						{capitalize(row.status)}
					</span>
				),
				wrap: true,
				sortable: true,
				sortField: 'status',
			},
			...(key === 'pending' ? [
				{
					name: t('MEDICIENS.TABLE.APPROVE'),
					cell: row => (
						<FaRegCheckCircle
							style={{ color: 'green', cursor: 'pointer' }}
							size={20}
							onClick={() => approval({ id: row.id, action: 'approve' })}
						/>
					),
					button: true,
					minWidth: '70px',
					grow: 0
				},
				{
					name: t('MEDICIENS.TABLE.REJECT'),
					cell: row => (
						<FaRegTimesCircle
							style={{ color: 'red', cursor: 'pointer' }}
							size={20}
							onClick={() => approval({ id: row.id, action: 'reject' })}
						/>
					),
					button: true,
					minWidth: '70px',
					grow: 0
				}
			] : [
				{
					cell: (row) => (
						<Button variant="warning" size="sm" onClick={() => handleEdit(row.id)}>
							<FaEdit style={{ color: 'white' }} />
						</Button>
					),
					button: true,
					minWidth: '70px',
					grow: 0
				}
			])
		];
	}, [key, currentPage, perPage, approval, t, handleEdit]);
};

export const useGetMedicineTypeOptions = ({ t }) => {
	return useMemo(() => [
		{ value: '', label: t('GENERAL.SELECT_OPTION') },
		{ value: 'TAB', label: t('MEDICIENS.TYPE.TAB') },
		{ value: 'CAP', label: t('MEDICIENS.TYPE.CAP') },
		{ value: 'SYRUP', label: t('MEDICIENS.TYPE.SYRUP') },
		{ value: 'DROP', label: t('MEDICIENS.TYPE.DROP') },
		{ value: 'CREAM', label: t('MEDICIENS.TYPE.CREAM') },
		{ value: 'INJ', label: t('MEDICIENS.TYPE.INJ') },
		{ value: 'BOTTLE', label: t('MEDICIENS.TYPE.BOTTLE') },
		{ value: 'SOLUTION', label: t('MEDICIENS.TYPE.SOLUTION') },
		{ value: 'OINTMENT', label: t('MEDICIENS.TYPE.OINTMENT') },
	], [t]);
};
